// src/services/notificationService.ts

import { apiClient } from "./apiClient";
import { NotificationPage } from "../models/NotificationModel";

/**
 * Get paginated notifications for the authenticated user, newest first.
 */
export const getNotifications = async (
  page = 0,
  size = 20
): Promise<NotificationPage> => {
  const params = new URLSearchParams({
    page: String(page),
    size: String(size),
  });
  return apiClient.get<NotificationPage>(`/api/notifications?${params}`);
};

/**
 * Get total unread notification count for the bell badge.
 */
export const getNotificationUnreadCount = async (): Promise<number> => {
  const data = await apiClient.get<{ totalUnread: number }>(
    "/api/notifications/unread-count"
  );
  return data.totalUnread;
};

/**
 * Mark a single notification as read.
 */
export const markNotificationAsRead = async (
  notificationId: number
): Promise<void> => {
  await apiClient.put<void>(`/api/notifications/${notificationId}/read`, {});
};

/**
 * Mark all notifications as read in a single request.
 */
export const markAllNotificationsAsRead = async (): Promise<void> => {
  await apiClient.put<void>("/api/notifications/read-all", {});
};